import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Booking, BookingsStore } from "@fry/booking/lib/bookings";
import { BuilderStateService } from "@fry/components/common/form-builder/builder.state.service";
import { User } from "@fry/lib/users";
import { ProfileStore } from '@fry/lib/profile';
import { switchMap, tap } from "rxjs";
import { FileUploadControlComponentDelegate } from "@fry/components/common/file-upload-control";
import { BookingFileUploadDelegate } from "../booking-edit/booking-file-upload.service";

export interface BookingPreviewData {
    doc: any;
    bookingOption: any;
}

@Component({
    selector: 'eas-booking-preview',
    templateUrl: 'booking-preview.component.html',
    providers: [
        BuilderStateService,
        { provide: FileUploadControlComponentDelegate, useClass: BookingFileUploadDelegate },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingPreviewComponent {
    public booking: Booking;
    public bookingOption: any;
    public user: User;
    public easFormGroup$ = this.builderState.easFormGroup$;
    public state$ = this.builderState.state$;

    constructor(
        public dialogRef: MatDialogRef<BookingPreviewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: BookingPreviewData,
        private builderState: BuilderStateService,
        private bookings: BookingsStore,
        private profile: ProfileStore,
        private fileUploadDelegate: FileUploadControlComponentDelegate,
    ) {
        this.booking = this.bookings.createObject(this.data);
        this.fileUploadDelegate.setContext({ oid: this.booking.id });
        this.user = this.booking.owner;
        this.bookingOption = this.booking.bookingOption;
        this.loadForm(this.bookingOption.form).subscribe();
    }

    loadForm(form: any) {
        return this.profile.getCurrent().pipe(
            switchMap((user) => {
            return this.builderState.initReadonly(form,
                                            this.booking,
                                            this.booking.doc.data || {},
                                            this.booking.workflow,
                                            this.booking.owner,
                                            user);
            }),
            tap(() => {
                this.builderState.watchTransitions();
            //     this.readOnlyGroup = this.builderState.snapshot.group.readOnlyGroup;
            //     this.setupButtons();
            })
        );
    }

    onCancel() {
        this.dialogRef.close();
    }
}
